const errormsg = {
  // 分割処理エラーメッセージ（運営用）
  DETAIL_SPLIT_ERROR_MSG: {
    100: '想定外のエラー',
    101: 'configファイルエラー',
    102: '生データ取得エラー',
    103: '条タイトルエラー',
    104: 'Configで定義されたエラー',
    105: '画像が含まれているエラー',
    106: '目次が含まれているエラー',
    107: '契約書タイトルエラー',
    108: '前文エラー',
    109: '冒頭文か署名エラー',
    110: '署名取得できないエラー',
    111: '結び文エラー',
    112: '条文形式エラー',
    113: 'PDFが保護されているか、編集権限ないエラー',
    114: '別紙エラー',
    115: '表エラー'
  },
  ERROR_MSG_REPLACE: '|MSG|',
  SYSTEM_ERROR_TEMPLATE:
    'エラーメッセージ：|MSG|' +
    '\n\nこのエラーについてのお問い合わせは、上記のエラーメッセージをご記入の上こちらのアドレスまでお願いいたします。' +
    '\nメール：support@lecheck.jp',
  BROWSER_ENV_ALERT:
    '動作推奨ブラウザは「Google Chrome(グーグル クローム)」「Microsoft Edge(マイクロソフト エッジ)」最新版です。ブラウザを切り替えてご利用ください。',
  BLOCK_PREVIEW_MESSAGE: 'プレビュー機能は動作推奨ブラウザでのみご利用が可能です。ブラウザを切り替えてご利用ください。'
};

export default errormsg;



// WEBPACK FOOTER //
// ./src/constants/errormsg.js